import { PUBLIC_ROUTE } from "../../../../route.constants";
import { smoothScroll } from "@utils/helpers/smoothScroll";
import { createIdQueryString } from "../util";
import { setupLoanRoute } from "@utils/helpers/navigators";
import { VERIFY_ROUTES } from "../../../../constants/commonConstants";

const shouldRouteBeActive = (loanFormState) => {
  const { verify } = loanFormState || {};
  const { nextScreen = "" } = verify || {};

  const stateContainsVerifyStep = nextScreen !== "";
  const verifyStepIsNotThankYou = nextScreen !== VERIFY_ROUTES.THANK_YOU;

  return stateContainsVerifyStep && verifyStepIsNotThankYou;
};

const navigateTo = (navigate, loanFormState) => {
  const { verify } = loanFormState || {};
  const { nextScreen } = verify || {};
  
  navigate(`${PUBLIC_ROUTE.VERIFY}/${nextScreen}` + createIdQueryString(loanFormState));
  
  smoothScroll();
};

export const verifyNavigation = setupLoanRoute({shouldRouteBeActive, navigateTo});